export const UsdtPremiumEvent = {
  UsdtPremiumDetailClick: 'usdt_premium_detail_click',
  AddUsdtPremiumClick: 'add_usdt_premium_click',
  UsdtPremiumConfirmClick: 'usdt_premium_confirm_click',
  UsdtPremiumTradeClick: 'usdt_premium_trade_click',
} as const;

export interface UsdtPremiumEventDataType {
  [UsdtPremiumEvent.UsdtPremiumDetailClick]: {
    usdt_asset: number;
    clicked_text: string;
    fifteen_days_volume: number;
  };
  [UsdtPremiumEvent.UsdtPremiumConfirmClick]: {
    usdt: number;
    manage_type: 'Add' | 'Reduce';
  };
}
